import { render } from "./BaseCard.vue?vue&type=template&id=6b645d99&scoped=true"
const script = {}

import "./BaseCard.vue?vue&type=style&index=0&id=6b645d99&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6b645d99"

export default script